// extracted by mini-css-extract-plugin
export default {"wrapper":"GuestCategory_wrapper__0-iNq","heading":"GuestCategory_heading__QwLIa","body":"GuestCategory_body__A-uYT"};